import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useMemo } from 'react';
import { EntityForm } from '../../../common/entityFramework/entityForm/EntityForm';
import { EntityDetail } from '../../../common/entityFramework/entityDetail/EntityDetail';

export const SuiteTestDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = useMemo(() => {
    return  [
      { id: 'infoTab', label: 'Info', content: <EntityForm /> }
    ]
  }, [entityObj]);

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}